import React, { useState } from 'react';
import { Card, PageContainer, Styles } from '~/components';
import MaskedInput from 'react-text-mask';
import { RGA_PATTERN } from '~/lib/textMaskPatterns';
import { useNavigate } from 'react-router-dom';
import usePageTitle from '~/hooks/usePageTitle';

const ClinicalCare: React.FC<{ title: string }> = ({ title }) => {
  const [value, setValue] = useState('');
  const [searchByProtocol, setSearchByProtocol] = useState(false);
  const navigate = useNavigate();
  usePageTitle({ title });

  function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const searchValue = value.trim();
    if (searchByProtocol) {
      navigate(`/clinical-care/protocol/${searchValue}`);
      return;
    }
    navigate(`/clinical-care/${searchValue}`);
  }

  function toggleSearchType() {
    setValue('');
    setSearchByProtocol((current) => !current);
  }

  return (
    <PageContainer>
      <form onSubmit={onSubmit}>
        <div className="full-header-height flex-centered">
          <Card.Base style={{ width: '40%', maxWidth: 500 }}>
            <Card.Header>
              <div className="columns align-center col-gapless">
                <div className="column col-auto mr-2 mt-1">
                  <Styles.Logo style={{ width: 28 }} />
                </div>
                <div className="column">
                  <div className="h5">Consultar atendimento clínico</div>
                </div>
              </div>
            </Card.Header>
            <Card.Body>
              <div className="divider" />
              <div className="text-center py-2">
                {
                  searchByProtocol ? (
                    <>
                      Informe o
                      {' '}
                      <b>número do protocolo</b>
                      {' '}
                      do atendimento.
                    </>
                  ) : (
                    <>
                      O
                      {' '}
                      <b>código do atendimento</b>
                      {' '}
                      está disponível no aplicativo web.
                    </>
                  )
                }
              </div>
              <div className="divider" />
              <div className="form-group text-center py-2">
                {
                  searchByProtocol ? (
                    <>
                      <label htmlFor="input-protocol-number">Entre com o número do protocolo</label>
                      <input
                        className="form-input text-center"
                        placeholder='Ex.: "260101A1B2CD"'
                        onChange={({ target }) => setValue(target.value)}
                        value={value}
                        type="text"
                        id="input-protocol-number"
                      />
                    </>
                  ) : (
                    <>
                      <label htmlFor="input-rga">Entre com o código do atendimento</label>
                      <MaskedInput
                        className="form-input text-center"
                        placeholder='Ex.: "9999.9999.9999.9999.9999"'
                        mask={RGA_PATTERN}
                        onChange={({ target }) => setValue(target.value.replace(/\D/g, ''))}
                        type="tel"
                        id="input-rga"
                      />
                    </>
                  )
                }
                <button type="button" className="btn btn-link btn-sm mt-2" onClick={toggleSearchType}>
                  {searchByProtocol ? 'Buscar pelo código do atendimento' : 'Buscar pelo número de protocolo'}
                </button>
              </div>
              <div className="divider" />
            </Card.Body>
            <Card.Footer>
              <div className="text-right">
                <button
                  type="submit"
                  disabled={searchByProtocol ? !value.trim() : value.length < 20}
                  className="btn btn-primary"
                >
                  <i className="fas fa-search" />
                  &nbsp;Buscar atendimento clínico
                </button>
              </div>
            </Card.Footer>
          </Card.Base>
        </div>
      </form>
    </PageContainer>
  );
};

export default ClinicalCare;
